import React, { useState, useEffect, useContext, useRef } from 'react';
import './SimpleCheckbox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function SimpleCheckbox({ selected: propsSelected, validate, label, name, onValidate, toggleSelection }) {
  const [selected, setSelected] = useState(!!propsSelected);
  const [needsToggleSelection, setNeedsToggleSelection] = useState(false);
  const nativeCheckbox = useRef(null);

  const selectedRef = useRef(!!propsSelected);
  const setSelectedRef = (el) => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox setSelectedRef'); }
    selectedRef.current = el;
    setSelected(el);
  }

  if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox rendered'); }

  useEffect(() => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox useEffect [validate]'); }
    submitValue();
  }, [validate])

  useEffect(() => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox useEffect [propsSelected]'); }
    setSelectedRef(propsSelected);
  }, [propsSelected])

  useEffect(() => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox useEffect [needsToggleSelection]'); }
    if (needsToggleSelection === true) {
      if (toggleSelection) {
        toggleSelection({
          selected: selectedRef.current,
          name: name
        });
      }
      setNeedsToggleSelection(false);
    }
  }, [needsToggleSelection])

  const submitValue = () => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox submitValue'); }
    let obj = {
      name: name,
      isValid: true,
      value: selectedRef.current
    };

    if (onValidate instanceof Function) {
      onValidate(obj);
    }
  }

  const toggleSelected = () => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox toggleSelected'); }
    setSelectedRef(!selectedRef.current);
    setNeedsToggleSelection(true);
  }

  const setNativeCheckboxRef = (el) => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox setNativeCheckboxRef'); }
    nativeCheckbox.current = el;
  }

  const clickNativeCheckbox = () => {
    if (logComponent('SimpleCheckbox')) { console.debug('SimpleCheckbox clickNativeCheckbox'); }
    if (nativeCheckbox) nativeCheckbox.current.click();
  }

  return (
    <div className="Simple-Checkbox">
      <input
        ref={setNativeCheckboxRef}
        type="checkbox"
        className="Simple-Checkbox__native-checkbox"
        id={name + '-input'}
        name={name}
        checked={selected}
        onChange={toggleSelected} />
      <div className="Simple-Checkbox__outline" onClick={clickNativeCheckbox}>
        <FontAwesomeIcon className={'Simple-Checkbox__check' + (selectedRef.current ? ' visible' : '')} icon="check"></FontAwesomeIcon>
      </div>
      <label
        className="Simple-Checkbox__label"
        htmlFor={name + '-input'}>
        {label}
      </label>
    </div>
  );
}